export const NOT_FOUND = "لا يوجد حساب بنكى لهذا المستخدم";
export const BANK_NAME_AR = "اسم البنك:";
export const USERNAME = "اسم المستفيد:";
export const IBAN = "رقم الحساب المصرفى الدولى IBAN :";
export const BANK_NAME_EN = "Bank Name:";
export const SWIFT = " Swift :";
